export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informações do contratante"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Conta / E-mail / Telefone"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Endereço cripto / E-mail / Telefone"])}
}